import * as styles from "./TabsContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useTabsContext } from "./Tabs.context";
import type { TabsContentProps } from "./Tabs.types";

export function TabsContent({
  className,
  children,
  ...props
}: TabsContentProps): JSX.Element {
  const { size, variant, orientation, flushStart, flushEnd } = useTabsContext();

  return (
    <div
      data-slot="tabs-content"
      className={clsx(
        styles.content({ size, variant, orientation, flushStart, flushEnd }),
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
